import { DashboardDTO } from "api/bookAppointmentOnline/get-book-appointment-dashboard-items";
import { BookAppointmentOnlineItemModel } from "./BookAppointmentOnlineItemModel";
import { OptionTypes } from "views/AppointmentBookOnlineWidgetView/types";

export type ConsentType = {
    Show: boolean;
    Content: string;
    Link?: string;
}

export class BookAppointmentOnlineDashboardModel {
    private logo?: string;
    private map?: string;
    private company: string;
    private address: string;
    private about: string;
    private redirectUrl?: string;
    private list: BookAppointmentOnlineItemModel[];
    private option: OptionTypes;
    private agreementConsent: ConsentType;
    private personalDataConsent: ConsentType;
    private marketingConsent: ConsentType;

    constructor(definition: DashboardDTO) {
        Object.keys(definition).forEach((name: string) => {
            this[name] = definition[name];
        });

        this.list = [];
        definition.list.forEach(
            (item) => item && this.list.push(new BookAppointmentOnlineItemModel(item))
        );
    }

    public getLogo(): string | null {
        return this.logo;
    }
    public getMap(): string | null {
        return this.map;
    }
    public getCompany(): string {
        return this.company;
    }
    public getAddress(): string {
        return this.address;
    }
    public getRedirectUrl(): string | null {
        return this.redirectUrl;
    }
    public getAbout(): string {
        return this.about;
    }
    public getList(): Array<BookAppointmentOnlineItemModel> {
        return this.list;
    }
    public getOption(): OptionTypes {
        return this.option;
    }
    public getAgreementConsentConfig(): ConsentType {
        return this.agreementConsent;
    }
    public getPersonalDataConsentConfig(): ConsentType {
        return this.personalDataConsent;
    }
    public getMarketingConsentConfig(): ConsentType {
        return this.marketingConsent;
    }

}
